import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const biopakPeriodManagementRoute: RouteConfig<'with-page'> = {
    name: 'Period Manage',
    path: '/biopak/periods/:periodId',
    page: lazy(() => import('.')),
    roles: ['ncassAdmin'],
    flags: ['no-menu-item'],
}